import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QComponent } from '@org/components';
import { AuthService } from '@org/shared-services';

@Component({
    selector: 'app-qand-a',
    imports: [CommonModule, QComponent],
    templateUrl: './QandA.component.html',
    styleUrl: './QandA.component.scss'
})
export class QandAComponent {
  isGM: boolean = false;
  isTech: boolean = false;
  isDeveloper: boolean = false;
  isScrolled = false;
  private ticking = false;

  constructor(private authService: AuthService) {
    this.isGM = this.authService.hasRole('gm');
    this.isTech = this.authService.hasRole('tech');
    this.isDeveloper = this.authService.hasRole('developer');
  }

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   if (!this.ticking) {
  //     window.requestAnimationFrame(() => {
  //       this.isScrolled = window.scrollY > 0;
  //       this.ticking = false;
  //     });
  //     this.ticking = true;
  //   }
  // }

  // // Optional: Clean up
  // ngOnDestroy() {
  //   this.ticking = false;
  // }
}
